<template>
  <el-row>
    <el-col class="flexbox">
      <form-item
        :label="$t('CampaignForm_ConsentPreferenceSetup_SelectPreference')"
        class="preference-select"
      >
        <el-select
          ref="preferenceSelect"
          v-model="value.consent_preference_name"
          filterable
          clearable
          :loading="loading"
          :placeholder="
            $t(
              'CampaignForm_ConsentPreferenceSetup_SelectPreference_Placeholder'
            )
          "
        >
          <el-option-group>
            <el-option
              :key="0"
              :label="
                $t(
                  'CampaignForm_ConsentPreferenceSetup_SelectPreference_IgnoreSubscriptionOption'
                )
              "
              value="0"
            />
          </el-option-group>

          <el-option-group>
            <el-option
              v-for="(item, index) in availablePreferences"
              :key="index"
              :label="
                `${getTruncatedName(item.name)} (${$t(
                  consentPreferenceType[item.type]
                )})`
              "
              :value="item.name"
              class="preference-option"
            >
              <span class="preference-name">{{ item.name }}</span>
              <span class="preference-type">{{
                $t(consentPreferenceType[item.type])
              }}</span>
            </el-option>
          </el-option-group>
        </el-select>
      </form-item>
    </el-col>
  </el-row>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import FormItem from '@/common/components/form/FormItem'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import { consentPreferenceType } from '@/modules/consent-manager/enum/ConsentPreferenceEnums'
import { ConsentChannels } from '@/modules/profiles/enum/ConsentChannelEnum'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'ConsentPreferenceSetup',
  components: { FormItem },
  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      preferences: [],
      consentPreferenceType,
      ConsentChannels,
      loading: false,
      maxNameCharacters: 50
    }
  },

  mounted() {
    this.fetchConsentPreferencesRemote()
    this.$nextTick(() => {
      this.calculateMaxNameCharacters()
    })
  },

  methods: {
    fetchConsentPreferencesRemote() {
      this.loading = true
      new RestApiPaginator(
        projectEndpoint({
          method: 'get',
          url: `consent-subscription-preferences`,
          params: {
            sort: 'name'
          }
        })
      )
        .fetchAllPages()
        .then(data => {
          this.preferences = data
          if (this.value.consent_preference_name) {
            this.setPreferenceAvailableChannels()
          }
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTruncatedName(name) {
      const truncatedName =
        name.length > this.maxNameCharacters
          ? name.substring(0, this.maxNameCharacters) + '...'
          : name
      return `${truncatedName}`
    },

    calculateMaxNameCharacters() {
      const el = this.$refs.preferenceSelect
      if (el) {
        const width = el.$el.offsetWidth
        this.maxNameCharacters = Math.floor(width / 10) - 11
      }
    },
    setPreferenceAvailableChannels() {
      let selectedPreference = this.preferences.find(p => {
        return p.name === this.value.consent_preference_name
      })
      let channels = null
      if (selectedPreference) {
        channels = this.systemChannels.filter(
          key => selectedPreference.channelList[key] === 1
        )
      }
      EventBus.$emit('set-preference-available-channels', channels)
    }
  },
  watch: {
    'value.consent_preference_name': {
      handler() {
        this.setPreferenceAvailableChannels()
      }
    }
  },
  computed: {
    systemChannels() {
      return Object.values(ConsentChannels)
    },
    availablePreferences() {
      return this.preferences.filter(item => {
        return this.systemChannels.some(channel => {
          return item.channelList && item.channelList[channel] === 1
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.flexbox {
  display: flex;
  .preference-select {
    width: 100%;
  }
}
.preference-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: auto;
}
.preference-type {
  color: #c2c2c3;
  font-size: 13px;
}
.preference-option {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/ConsentPreferenceSetup.vue